import PropTypes from 'prop-types';

/* eslint-disable import/prefer-default-export */

export const talModelPropType = PropTypes.shape({
	lift: PropTypes.arrayOf(PropTypes.number),
	percentile: PropTypes.arrayOf(PropTypes.number),
	total_users: PropTypes.number,
	engaged_users: PropTypes.number,
});

export const traitPropType = PropTypes.shape({
	id: PropTypes.number,
	code: PropTypes.string,
	trait: PropTypes.string,
	traitType: PropTypes.string,
	subType: PropTypes.string,
	factor: PropTypes.string,
	description: PropTypes.string,
	highRangeName: PropTypes.string,
	lowRangeName: PropTypes.string,
	highRangeDesc: PropTypes.string,
	lowRangeDesc: PropTypes.string,
	oceanPosition: PropTypes.number,
});

export const traitsPropType = PropTypes.arrayOf(traitPropType);

export const pxScorePropType = PropTypes.shape({
	trait: traitPropType,
	score: PropTypes.number,
}).isRequired;

export const pxHistogramPropType = PropTypes.shape({
	trait: traitPropType,
	frequencies: PropTypes.arrayOf(PropTypes.number),
	values: PropTypes.arrayOf(PropTypes.number),
}).isRequired;

export const pxScoresPropType = PropTypes.arrayOf(pxScorePropType);

export const pxHistogramsPropType = PropTypes.arrayOf(pxHistogramPropType);

export const stylePropType = PropTypes.shape({
	itemStyle: PropTypes.shape({
		all: PropTypes.shape({}),
	}),
	label: PropTypes.shape({
		all: PropTypes.shape({}),
	}),
	tooltip: PropTypes.shape({
		all: PropTypes.shape({}),
	}),
});
